import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// import * as VueGoogleMaps from 'vue2-google-maps'
import { GoogleCharts } from 'google-charts';
// import { mapTheme } from '@/components/WorldMapHeat/MapTheme';
// import MapGeo from '@/components/WorldMapHeat/geo.json';

@Component<WorldMapHeat>({
  components: {
  },
})
export default class WorldMapHeat extends Vue {
  @Prop()
  protected mapStyle?: string;

  @Prop({default: function () { return {lat:51.441643, lng: 5.469722} }})
  protected mapCenter?: MapCenter;

  @Prop({default: 2})
  protected mapZoom?: number;

  @Prop()
  protected mapData!: any;
  
  // protected mapGeo: any = MapGeo;

  public mounted() {
    GoogleCharts.load(this.drawRegionsMap, {
      'packages': ['geochart'],
      'mapsApiKey': process.env.VUE_APP_GEO_API_KEY,
    });
    window.addEventListener('resize', this.drawRegionsMap);
  }

  public destroyed() {
    window.removeEventListener('resize', this.drawRegionsMap);
  }


  protected drawRegionsMap() {
    var data = GoogleCharts.api.visualization.arrayToDataTable(this.mapData);

    var options = {
      enableScrollWheel: true,
      colorAxis: {colors: ['#ccfff1', '#003325']},
      backgroundColor: '#fafcff',
      datalessRegionColor: '#eef0f2',
      defaultColor: '#f5f5f5',
      tooltip: {textStyle: {color: '#003325'}},
    };

    var chart = new GoogleCharts.api.visualization.GeoChart(document.getElementById('geochart-colors'));
    chart.draw(data, options);
  };

  protected setStyle(feature: any) {
    return /** @type {GoogleCharts.api.maps.Data.StyleOptions} */({
      fillColor: 'green',
      strokeColor: 'green',
      strokeWeight: 2,
  });
  }

  @Watch('mapData', {deep: true})
  protected mapDataWatch(to: any) {
    this.drawRegionsMap();
  }
}

interface MapCenter {
  lat: number;
  lng: number;
}